import React from 'react';
import SignaturePad from 'react-signature-canvas';
import { Button, Icon } from 'framework7-react';
import PropTypes from 'prop-types';
import II18 from '../../translate/II18';
import { getImageSize } from '../../../lib/fileUtils';

class SignPad extends React.Component {
  state = {};

  constructor(props) {
    super(props);
    this.signaturePad = React.createRef();
    this.tmpCanvas = document.createElement('canvas');

    const pad_props = {};
    pad_props.ref = this.signaturePad;
    pad_props.minWidth = 2;
    pad_props.maxWidth = 4;
    pad_props.clearOnResize = false;
    pad_props.onBegin = this.onSigBegin;
    pad_props.onEnd = () => this.forceUpdate();
    this.pad_props = pad_props;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      prevProps.popupOpened !== this.props.popupOpened &&
      this.props.popupOpened
    ) {
      setTimeout(() => this.forceUpdate(), 100);
    }
  }

  onSigBegin = () => {
    this.props.onSigBegin && this.props.onSigBegin();
    this.forceUpdate();
  };

  clear = justClear => {
    if (this.signaturePad.current) {
      if (!justClear && this.signaturePad.current.isEmpty()) {
        this.props.onCancel();
        return;
      }

      const tmpCtx = this.tmpCanvas.getContext('2d');
      tmpCtx.clearRect(0, 0, this.tmpCanvas.width, this.tmpCanvas.height);

      this.signaturePad.current.clear();
      this.forceUpdate();
    }
  };

  truncate(source, size) {
    return source && source.length > size
      ? source.slice(0, size - 1) + '…'
      : source;
  }

  applySignature = () => {
    const isEmpty =
      !this.signaturePad.current || this.signaturePad.current.isEmpty();

    if (isEmpty) {
      this.props.onDone('');
      this.clear(true);
    } else {
      getImageSize(
        this.signaturePad.current.getTrimmedCanvas().toDataURL(),
        size => {
          if (size.width < 5 && size.height < 5) {
            this.props.onToSmall();
          } else {
            this.props.onDone(
              this.signaturePad.current.getTrimmedCanvas().toDataURL()
            );
            this.clear(true);
          }
        }
      );
    }
  };

  render() {
    const container = document.getElementById('signPadContainer');
    const canvasProps = {
      width: container?.offsetWidth - 30 || 0,
      height: container?.offsetHeight - 20 || 0
    };

    const isEmpty =
      !this.signaturePad.current || this.signaturePad.current.isEmpty();

    return (
      <div
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <div id={'signPadContainer'} style={{ flexGrow: 1 }}>
          <div className={'signatureRect'}>
            <SignaturePad {...this.pad_props} canvasProps={canvasProps} />
          </div>
          <label style={{ bottom: 85 }} className={'signaturePlace'}>
            X
          </label>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: 12
          }}
        >
          <div
            title={this.props.title}
            style={{ fontSize: 14, fontWeight: 'bold' }}
          >
            {this.truncate(this.props.title, 60)}
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-end',
              gap: 10
            }}
          >
            {!isEmpty && (
              <Button
                id={'clearSignature'}
                color={'red'}
                raised
                onClick={() => this.clear()}
                text={II18.get(isEmpty ? 'title_cancel' : '')}
              >
                <Icon material={'clear'} />
              </Button>
            )}
            <Button
              id={'cancelEditSignature'}
              raised
              onClick={this.props.onCancel}
              text={II18.get('title_cancel')}
            ></Button>
            <Button
              id={'confirmSignature'}
              raised
              fill
              onClick={() => this.applySignature()}
            >
              <Icon material={'check'} style={{ marginRight: 10 }} />
              {II18.get('title_confirm')}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

SignPad.propTypes = {
  onToSmall: PropTypes.func,
  onCancel: PropTypes.func,
  onDone: PropTypes.func,
  onSigBegin: PropTypes.func,
  title: PropTypes.string,
  popupOpened: PropTypes.bool
};

export default SignPad;
